/**
 * Stripe API Key patterns:
 *
 * Stripe uses several types of API keys for payment processing.
 *
 * Patterns:
 * 1. Stripe Secret Key (Live):
 *    - Starts with 'sk_live_'
 *    - Followed by 24+ alphanumeric characters
 *
 * 2. Stripe Secret Key (Test):
 *    - Starts with 'sk_test_'
 *    - Followed by 24+ alphanumeric characters
 *
 * 3. Stripe Restricted Key:
 *    - Starts with 'rk_live_' or 'rk_test_'
 *    - Followed by 24+ alphanumeric characters
 *
 * 4. Stripe Publishable Key:
 *    - Starts with 'pk_live_' or 'pk_test_'
 *    - Note: Less sensitive but still tracked
 *
 * Examples:
 * - Live Secret Key: `sk_live_1234567890abcdefghijklmnopqrstuvwxyz`
 * - Test Secret Key: `sk_test_1234567890abcdefghijklmnopqrstuvwxyz`
 * - Restricted Key: `rk_live_1234567890abcdefghijklmnopqrstuvwxyz`
 *
 * References:
 * - https://stripe.com/docs/keys
 * - https://stripe.com/docs/security/best-practices
 */

export const stripeSecretKey = /\b(s|r|p)k_(live|test)_[A-Za-z0-9]{24,}/;
